import { AudioSettingsTabWrapper as AudioSettingsTab } from "../components/settings-drawer/AudioSettingsTab";
import { BackgroundSettingsTabWrapper as BackgroundSettingsTab } from "../components/settings-drawer/BackgroundSettingsTab";
import { VideoSettingsTabWrapper as VideoSettingsTab } from "../components/settings-drawer/VideoSettingsTab";
import { AccessibilitySettingsTabWrapper as AccessibilitySettingsTab } from "../components/settings-drawer/AccessibilitySettingsTab";
import { SettingsDrawerTab } from "../components/settings-drawer/SettingsDrawer";
import { SelfVideoThumbnail } from "./SelfVideoThumbnail";

export const tabMap = {
  [SettingsDrawerTab.VIDEO]: (
    <VideoSettingsTab thumbnailComponent={SelfVideoThumbnail} />
  ),
  [SettingsDrawerTab.AUDIO]: <AudioSettingsTab />,
  [SettingsDrawerTab.BACKGROUND]: <BackgroundSettingsTab />,
  [SettingsDrawerTab.ACCESSIBILITY]: <AccessibilitySettingsTab />,
};
